module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/operations.54e0d4ac.svg";